import { Injectable } from '@angular/core';
import { LocalStorageService } from '@schoolbelle/common/local-storage';
import { AuthService } from '@schoolbelle/api/auth';
import { filter } from 'rxjs/operators';

const AuthorNamePrefix = 'sbe-board.writer';

@Injectable({
  providedIn:'root'
})
export class AuthorNameService {
  constructor (
    private storage:LocalStorageService, // 
    private auth:AuthService,
  ) {

    // when user logs out
    // remove all saved personal data.
    this.auth.user.pipe(
      filter(user=>user ? false : true) // when logged out
    )
    .subscribe(async()=>{
      this.clear();
    })
  }


  async get(gid:string|number) {
    return await this.storage.get(`${AuthorNamePrefix}.${gid}`);
  }  
  async keys ():Promise<string[]> {
    return (await this.storage.get(`${AuthorNamePrefix}.keys`) || '').split(',').filter(v=>v);

  }
  async set(gid:string|number, author_name:string) {
    const key = `${AuthorNamePrefix}.${gid}`;
    let keys = await this.keys();
    if (!keys.includes(key)) {
      keys.push(key);
      await this.storage.set(`${AuthorNamePrefix}.keys`, keys.join(','))
    }
    await this.storage.set(key, author_name);


  } 
  async remove (gid:string|number) {
    this.storage.remove(`${AuthorNamePrefix}.${gid}`);
    const key = `${AuthorNamePrefix}.${gid}`;
    let keys = await this.keys();
    if (keys.includes(key)) {
      keys.splice(keys.indexOf(key), 1);
      if (keys.length) await this.storage.set(`${AuthorNamePrefix}.keys`, keys.join(','))
      else await this.storage.remove(`${AuthorNamePrefix}.keys`);
    }

  } 

  async clear () {
    let keys = await this.keys();
    await Promise.all(keys.map(async(key)=>this.storage.remove(key)));
    await this.storage.remove(`${AuthorNamePrefix}.keys`)    
 
  }



}